<div class="d-flex align-items-center">
  <div>
    <h1 class="mb-2">{{title.$title | async}}</h1>
    <p>{{title.$subtitle | async}}</p>
  </div>
</div>
<router-outlet></router-outlet>
